import productApi from "@/api/product";
import omsUserApi from "@/api/omsUserApi";
import category from "@/api/category";
import nation from "@/api/nation";
import { formatCategories } from "@/utils/common";
const product = {
  state: {
    declareList: [],
  },
  mutations: {},
  actions: {
    omsUserList({ commit }, data) {
      return omsUserApi.list(data).then((res) => {
        return res;
      });
    },
    omsUserAddOrModify({ commit }, data) {
      return omsUserApi.addOrModify(data).then((res) => {
        return res;
      });
    },
    bindMerchant({ commit }, data) {
      return omsUserApi.bindMerchant(data).then((res) => {
        return res;
      });
    },
    bindCustomerId({ commit }, data) {
      return omsUserApi.bindCustomerId(data).then((res) => {
        return res;
      });
    },
    setWarehouseReceiptUser({ commit }, data) {
      return omsUserApi.setWarehouseReceiptUser(data).then((res) => {
        return res;
      });
    },
    changeUserStatus({ commit }, data) {
      return omsUserApi.changeUserStatus(data).then((res) => {
        return res;
      });
    },
    editUserPasswordDirect({ commit }, data) {
      return omsUserApi.editUserPasswordDirect(data).then((res) => {
        return res;
      });
    },
  },
};

export default product;
